initLottieInteractivity();

async function initLottieInteractivity() {
    try {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            // The user has enabled reduced motion
            console.log('Do not load Lottie animation');
            return
        } else {
            // The user has not enabled reduced motion
            const scriptsLoaded = await loadLottieScripts();
            console.log(scriptsLoaded); // true

            // Load the Lottie animation
            defineLottieInteractivity();
        }

    } catch (error) {
        console.error(error);
    }
}

function loadLottieScripts() {
    return new Promise((resolve, reject) => {

        // Load Lottie Interactivity script
        const lottieInteractivityScript = document.createElement('script');
        lottieInteractivityScript.src = 'https://unpkg.com/@lottiefiles/lottie-interactivity@latest/dist/lottie-interactivity.min.js';

        lottieInteractivityScript.onload = () => {

            // Load Lottie Player script
            const lottiePlayerScript = document.createElement('script');
            lottiePlayerScript.src = 'https://unpkg.com/@lottiefiles/lottie-player@1.5.7/dist/lottie-player.js';

            lottiePlayerScript.onload = () => {

                // Load Bodymovin script
                const bodymovinScript = document.createElement('script');
                bodymovinScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.7.4/lottie.min.js';

                bodymovinScript.onload = () => {

                    // Load DotLottie Player script
                    const dotLottiePlayerScript = document.createElement('script');
                    dotLottiePlayerScript.src = 'https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.js';

                    dotLottiePlayerScript.onload = () => {
                        resolve(true);
                    };

                    dotLottiePlayerScript.onerror = () => {
                        reject(new Error('Failed to load DotLottie Player script.'));
                    };

                    document.body.appendChild(dotLottiePlayerScript);
                };

                bodymovinScript.onerror = () => {
                    reject(new Error('Failed to load Bodymovin script.'));
                };

                document.body.appendChild(bodymovinScript);
            };

            lottiePlayerScript.onerror = () => {
                reject(new Error('Failed to load Lottie Player script.'));
            };

            document.body.appendChild(lottiePlayerScript);
        };

        lottieInteractivityScript.onerror = () => {
            reject(new Error('Failed to load Lottie Interactivity script.'));
        };

        document.body.appendChild(lottieInteractivityScript);
    });
}

async function createLottieInteractivity(animationUrl, visibility, frames, tagName) {
    class LottieOnScroll extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            console.log('Custom element is loaded!');
        }

        static get observedAttributes() {
            return ['lottie-sticky-trigger-element-id'];
        }

        attributeChangedCallback(name, oldValue, newValue) {

            if (name === 'lottie-sticky-trigger-element-id') {
                const obj = JSON.parse(newValue);
                const animationUrl = obj.lottieFileSource;
                const frames = JSON.parse(obj.numberOfFrames);
                const visibility = JSON.parse(obj.visibility);
                const containerSelector = obj.animationTriggerElement;
                const animaitonLinkType = isJsonLinkFromLottie(animationUrl);

                if (animaitonLinkType) {
                    // if (animaitonLinkType === 'Lottie file') {
                    const lottiePlayer = document.createElement('lottie-player');
                    lottiePlayer.src = animationUrl;
                    lottiePlayer.autoplay = false;
                    lottiePlayer.loop = true;
                    lottiePlayer.id = `lottie-${tagName}`;
                    this.appendChild(lottiePlayer);

                    lottiePlayer.addEventListener("ready", () => {
                        LottieInteractivity.create({
                            player: `#${lottiePlayer.id}`,
                            mode: "scroll",
                            container: `#${containerSelector}`,
                            actions: [{
                                visibility,
                                type: "seek",
                                frames,
                            }, ]
                        });
                    });
                    // }

                    // if (animaitonLinkType === 'Not Lottie file') {
                    //     // TODO
                    //     alert('NOT A LOTTIE LINK');
                    //     runBodymovingAnimation(animationUrl, containerSelector);

                    // }
                }

            }

        }
    }

    customElements.define(tagName, LottieOnScroll);
}

//*** For Bodymoving animation >> Not in use ***//
function runBodymovingAnimation(animationLink, containerSelector) {
    const animationContainer = document.getElementById(containerSelector);

    const animation = bodymovin.loadAnimation({
        container: animationContainer,
        renderer: 'svg',
        loop: false, // Disable looping
        autoplay: false,
        path: animationLink
    });

    let isScrolling = false;
    let animationFrameRequestId;
    let scrollProgress = 0; // Keep track of scroll progress

    function updateAnimationProgress() {
        const scrollY = window.scrollY || window.pageYOffset;
        const containerTop = animationContainer.getBoundingClientRect().top + scrollY;
        const containerHeight = animationContainer.clientHeight;
        const viewportHeight = window.innerHeight;
        scrollProgress = Math.max(0, Math.min(1, (scrollY - containerTop + viewportHeight) / containerHeight));
    }

    function playAnimationOnScroll() {
        updateAnimationProgress();

        const animationFrame = scrollProgress * animation.totalFrames;
        animation.goToAndStop(animationFrame, true);

        if (scrollProgress >= 1) {
            animation.playSegments([animation.totalFrames - 1, animation.totalFrames], true);
        } else {
            animation.play();
        }

        animationFrameRequestId = null;
    }

    function reverseAnimationOnScroll() {
        updateAnimationProgress();

        const animationFrame = scrollProgress * animation.totalFrames;
        animation.goToAndStop(animationFrame, true);

        if (scrollProgress <= 0) {
            animation.playSegments([0, 1], true);
        } else {
            animation.play();
        }

        animationFrameRequestId = null;
    }

    function handleScroll() {
        if (!isScrolling) {
            isScrolling = true;

            if (!animationFrameRequestId) {
                if (scrollProgress > 0) {
                    animationFrameRequestId = requestAnimationFrame(playAnimationOnScroll);
                } else {
                    animationFrameRequestId = requestAnimationFrame(reverseAnimationOnScroll);
                }
                isScrolling = false;
            }
        }
    }

    window.addEventListener("scroll", handleScroll);

    // Initial setup
    handleScroll();
}

function isJsonLinkFromLottie(link) {
    // Check if the link ends with ".json"
    if (!link.endsWith(".json")) {
        return false;
    } else {
        // Check if the link contains the Lottie host domain
        if (link.includes("lottie.host")) {
            // Extract the unique identifier from the link
            const uniqueIdMatch = link.match(/\/([a-f0-9-]+)\/[a-zA-Z0-9]+\.json/);
            if (uniqueIdMatch && uniqueIdMatch[1]) {
                console.log(link + " is a Lottie JSON link.");
                return 'Lottie file';
            }
        } else {
            console.log(link + " is a JSON but not a Lottie link.");
            return 'Not Lottie file';
        }
    }

    return false;
}

function defineLottieInteractivity() {
    // For example
    createLottieInteractivity('https://lottie.host/68736232-d881-489c-999e-f825a5c7e702/WfMItjJr6j.json', [0, 1], [0, 120], 'flying-documents');
    // createLottieInteractivity('https://assets8.lottiefiles.com/packages/lf20_kd8ZIYkRgP.json', [0, .8], [0, 488], 'd3-hologram');
}